export const URL = {
  KNOWLEDGE_BASE: {
    BASIC_SETTINGS: 'https://knowledge-base.yieldbird.com/refresher/basic-settings',
  },
} as const

export const NEW_VIEWPORT_ID_FIELD = 'refreshRedirect.mediaTypeRefreshers.newViewportId'
